import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="The forgotten duty of a sales person!" />

                      
<nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/forgotten-duty-sales-person/&amp;title=The%20forgotten%20duty%20of%20a%20sales%20person%21&amp;summary=The%20forgotten%20duty%20of%20a%20sales%20person%21&amp;source=https%3A//salestribe.com/knowledge-centre/insights/forgotten-duty-sales-person/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=The%20forgotten%20duty%20of%20a%20sales%20person%21&amp;url=https%3A//salestribe.com/knowledge-centre/insights/forgotten-duty-sales-person/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/forgotten-duty-sales-person/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/forgotten-duty-sales-person/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=The%20forgotten%20duty%20of%20a%20sales%20person%21&amp;body=https%3A//salestribe.com/knowledge-centre/insights/forgotten-duty-sales-person/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header" id="page-header">
    <div className="header__image" >
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/article-challenge-wheel.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>B2B Sales</h3>
                        <h1>The forgotten duty of a sales person!</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>16 June 2016</li>
                        <li>3 min read</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>Sales people are now failing to perform a critically important component of their role: the gathering of Market Intelligence (MI).</h3>
<ul><li>Whom (within your business) is closest to your customers and target markets?</li><li>Whom is best positioned to identify emerging trends and evolving customer requirements?</li><li>Whom should be able to spot the next '<em>pocket of growth'</em> in the market?</li></ul>
<div className="rich-text"><p>As the conduit between the organisation and its various markets the sales person is the key link between the external environment and the business. There is now overwhelming evidence that vendor sales people are so heavily fixated on short term financial performance that they have completely overlooked arguably the most important element of their role – <strong>understanding the customer.</strong>  Why do so many senior business leaders allow sales people to get away with NOT performing one of the most important duties of their role? – <em>gathering, synthesising and sharing market intelligence (MI)</em>.</p><p>We all know that innovation is the key to business sustainability and innovation is quite simply the application of better solutions to meet new customer requirements, un-articulated needs, or emerging market needs. According to Clayton Christensen, disruptive innovation is the key to future business success, but not all innovations are disruptive, even if they are revolutionary. Regardless of definition, in order for any business to be sustainable (and to retain competitive advantage) it is necessary to create and nurture an environment of innovation. How is this possible if the key personnel on the front line don’t bother feeding important market data back into the business?</p><p>If you consider the rapid rate of change now occurring across almost every industry it is more critical than ever before that vendor sales leaders regularly ‘zoom-out’ and take a careful look at their respective market places and the disruptive change that is taking place. It sounds so obvious, but in my experience many vendors rarely do this properly. This ‘zooming out’ to gather MI and feeding that data back into the vendor business is critical to business survival, innovation and continuous evolution in step with constantly (and rapidly) changing market conditions.</p><p>The renowned management author G. S. Day (1994) described it best when he stated that businesses must have an <strong>“<em>Outside-In Perspective”</em> </strong>and become what he refers to as “<em>market-sensing</em>” The theory being that this externally focused perspective creates a customer-centric approach that will ensure that all innovation and sales effort is actually relevant to market requirements. Whilst there are some positive signs of change in this area, there are still very few vendors today that can honestly say that they are truly <em>market sensing</em>. On the contrary, most vendor sales departments display an “Inside-Out perspective” where sales people spend more time in the office than they do actually engaged with their customers, and this pattern of behaviour will ultimately destroy business value whilst providing your competitors with a leg up.</p><p>Of course, it is one thing for sales people to collect MI, but it’s another thing entirely for businesses to then actually leverage this MI to help create sustainable competitive advantage. Business culture has a large part to play in this, but the fundamental fault here lies with sales leadership.</p><p> There are two simple sets of questions that sales leaders should ask themselves to evaluate whether the organisations they represent lean more towards an <em>Outside-In </em>or the opposite <em>Inside-Out</em> approach. </p><ul><li>Do you know who your target customer segments are, what needs and behaviour’s they have, how to best solve their relevant problems and what kind of value you provide them? Do you understand their strategy, competitive pressures and where their future requirements might be going?</li><li>Is there a strong fit between your target segments’ needs, your value proposition, your overall business model, internal processes and a customer-oriented organisational culture, with focus on creating value for your customers? And do you feel that this is a fundamental necessity of running a successful business?</li></ul><p>In summary, vendor businesses will fail to remain relevant with their customers in these times of unprecedented volatility, change and disruption if they are not <em>‘market-sensing’.</em> The successful vendors of the future will ensure that sales people are constantly on the lookout for game changing trends and emerging market requirements. It’s not the strongest that survive, but the most adaptable to change.</p><h3><strong>How to become ‘market sensing’?</strong></h3><ol><li>Job specification amendments to include obligations for sales people to regularly feed market intelligence back into the business.</li><li>Remove unnecessary internal duties and refocus sales people on collecting and understanding critical customer requirements.</li><li>Develop a heightened focus on external information gathering and knowledge sharing. Ensure that all sales staff become much more externally focused. Key trends and customer data must be regularly captured and shared appropriately.</li><li>Senior executives (C-Level) to spend 1 week per quarter working with the vendor sales team to ensure top-down understanding of current customer issues, market trends and potential new areas of innovation and diversification.</li><li>Investigate opportunities to utilize <em>Big Data</em> analytics to help inform more detailed understanding of market shifts and target customer requirements.</li></ol></div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/forgotten-duty-sales-person/&amp;title=The%20forgotten%20duty%20of%20a%20sales%20person%21&amp;summary=The%20forgotten%20duty%20of%20a%20sales%20person%21&amp;source=https%3A//salestribe.com/knowledge-centre/insights/forgotten-duty-sales-person/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=The%20forgotten%20duty%20of%20a%20sales%20person%21&amp;url=https%3A//salestribe.com/knowledge-centre/insights/forgotten-duty-sales-person/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/forgotten-duty-sales-person/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/forgotten-duty-sales-person/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=The%20forgotten%20duty%20of%20a%20sales%20person%21&amp;body=https%3A//salestribe.com/knowledge-centre/insights/forgotten-duty-sales-person/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-complete-waste-money-and-time-part-2" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>Sales Training’ is a waste of money and time (Part 2)</strong></h3>
                    </header>
                    <p>We must stop teaching sales people how to ‘push’ buyers, and instead start training and coaching them on how to become highly specialised teachers.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-waste-time-and-money-part-1" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>‘Sales Training’ is a waste of time and money (Part 1)</strong></h3>
                    </header>
                    <p>When you teach sales people how to ‘push’ buyers through a sales playbook you are teaching them how to destroy your business reputation.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/b2b-sales-has-changed-about-180-degrees" className="card card--article">
                <div className="card__thumb">
                    <img alt="Mentor Large Graham Hawkins" className="card__image" height="404" src="../../../media/images/Mentor-Large-Graham-Hawkins.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">04:28</span>
                    <span className="card__icon play-icon">
                        <i className="icon"></i>
                    </span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>B2B Sales has changed about 180 Degrees!</strong></h3>
                    </header>
                    <p>B2B sales has now changed so dramatically that it&#39;s a &quot;profession&quot; that is barely recognisable to the role that both Tony Hughes and Graham Hawkins began about 30 years ago - respectively.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>
      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 